export function extractStreetNameAndNumber(street: string): string[] {
  if (!street) {
    return ['', ''];
  }

  const trimmed = street.trim();

  // Match:
  //  - street name (anything)
  //  - number part: digits + optional space + optional letters
  const match = trimmed.match(/^(.+?)\s+(\d+\s*[A-Za-z]*)$/);

  if (!match) {
    return [street, ''];
  }

  const streetName = match[1].trim();
  const streetNumber = match[2].replace(/\s+/g, '');

  return [streetName, streetNumber];
}